import React from 'react'
import PropTypes from 'prop-types'
import Notice from './Notice'
import { connect } from 'react-redux'
import { updatePermissionNoticeStatus } from '../redux/modules/permissionNotice'

const PermissionNotice = ({
  permissionNotice,
  updatePermissionNoticeStatus,
}) => (
  <Notice
    onClose={() => updatePermissionNoticeStatus(false)}
    show={permissionNotice}
    title={__('Not available in Read-Only Access')}
  >
    {__(
      'You cannot submit any forms, make any changes or remove content from the user account in read-only access.',
    )}
  </Notice>
)

PermissionNotice.propTypes = {
  permissionNotice: PropTypes.bool,
  updatePermissionNoticeStatus: PropTypes.func,
}

export default connect(
  ({ permissionNotice }) => ({
    permissionNotice,
  }),
  { updatePermissionNoticeStatus },
)(PermissionNotice)
